import React from "react";
import { Button } from "pepsico-ds";
import TradeAnalyticsSidebar_img1 from '../../assets/TradeAnalyticsSidebar_img1.svg'
import TradeAnalyticsSidebar_img2 from '../../assets/TradeAnalyticsSidebar_img2.svg'
import TradeAnalyticsSidebar_img3 from '../../assets/TradeAnalyticsSidebar_img3.svg'
import TradeAnalyticsSidebar_img4 from '../../assets/TradeAnalyticsSidebar_img4.svg'

function TradAnalyticsSidePanel({responseData, page}) {
    
    if(page == "Procure360"){
            return(
                <>    
                    <div className="sidepanel-full-box">
                        <div className="sidepanel-header" style={{margin: '10px'}}>
                            Resources
                        </div>
                        <div style={{margin: '10px'}}>
                            <span className="sidepanel-sub-header" >Review these recommended onboarding resources for helpful, optional guidance.</span>
                        </div>
                        {
                            responseData && responseData?.procure360DashboardAccess ? (
                                <>
                                        <div className="sidepanel-sub-box">
                                            <div style={{marginTop: '10px', marginLeft: '10px'}}>
                                                <span>
                                                    <img src={TradeAnalyticsSidebar_img1}/>
                                                </span>
        
                                                <span className="sidepanel-sub-box-title" style={{fontSize: '13px'}}>1: Access the Procure 360 Dashboard</span>
        
                                                
                                            </div>
                                            <div className="sidepanel-sub-box-content" style={{fontSize: '12px', margin: '10px 15px'}}>
                                                Get the complete Procure 360 Dashboard, powered by IMARC (for Packaging Category Managers)
                                            </div>
                                            <div>
                                                <span style={{display: 'flex', justifyContent: 'flex-end'}}>
                                                    <Button
                                                        className=""
                                                        // iconTrailing={"arrow_forward"}
                                                        size="medium"
                                                        style={{color:"#034895", fontSize: '12px', marginRight: '10px'}}
                                                        text="Go to Procure 360"
                                                        variant="tertiary"
                                                        onClick={function clickButton() {
                                                            // window.open(ProcureAccess, "_blank", "noopener")
                                                            window.open(responseData?.procure360DashboardAccessURL, "_blank", "noopener")
                                                        }}
                                                    />
                                                </span>
                                                
                                            </div>
                                    </div>
                                </>
                            ) : <></>
                        }
                        
                        <div className="sidepanel-sub-box">
                                <div style={{marginTop: '10px', marginLeft: '10px'}}>
                                    <img src={TradeAnalyticsSidebar_img2}/>
                                    <span className="sidepanel-sub-box-title" style={{fontSize: '13px'}}>{responseData?.procure360DashboardAccess ? "2" : "1"}: Procure 360 Power BI Access</span>
                                </div>
                                <div className="sidepanel-sub-box-content" style={{fontSize: '12px', margin: '10px 15px'}}>
                                    Download the Power BI Desktop file to access the Procure 360 Dashboard, powered by IMARC (for all roles)
                                </div>
                                <div>
                                    <span style={{display: 'flex', justifyContent: 'flex-end'}}>
                                        <Button
                                                className=""
                                                // iconTrailing={"arrow_forward"}
                                                size="medium"
                                                style={{color:"#034895", fontSize: '12px', marginRight: '10px'}}
                                                text="Download PBI file"
                                                variant="tertiary"
                                                onClick={function clickButton() {
                                                    window.open(responseData?.procure360PowerBIAccessURL, "_blank", "noopener")
                                                }}
                                        />
                                    </span>
                                    
                                </div>
                        </div>
                        <div className="sidepanel-sub-box">
                                <div style={{marginTop: '10px', marginLeft: '10px'}}>
                                    <img src={TradeAnalyticsSidebar_img3}/>
                                    <span className="sidepanel-sub-box-title" style={{fontSize: '13px'}}>{responseData?.procure360DashboardAccess ? "3" : "2"}: Explore Navigation Guides</span>
                                </div>
                                <div className="sidepanel-sub-box-content" style={{fontSize: '12px', margin: '10px 15px'}}>
                                    Go through the Video/Manual to know more
                                </div>
                                <div>
                                    <span style={{display: 'flex', justifyContent: 'flex-end'}}>
                                        <Button
                                            className=""
                                            // iconTrailing={"arrow_forward"}
                                            size="medium"
                                            style={{color:"#034895", fontSize: '12px', marginRight: '10px'}}
                                            text="Watch Video"
                                            variant="tertiary"
                                            onClick={function clickButton() {
                                                window.open(responseData?.navigationGuideVideoURL, "_blank", "noopener")
                                            }}
                                        />
                                        <Button
                                            className=""
                                            // iconTrailing={"arrow_forward"}
                                            size="medium"
                                            style={{color:"#034895", fontSize: '12px', marginRight: '10px'}}
                                            text="View Manual"
                                            variant="tertiary"
                                            onClick={function clickButton() {
                                                window.open(responseData?.navigationGuideManualURL, "_blank", "noopener")
                                            }}
                                        />
                                    </span>
                                    
                                </div>
                        </div>
                        <div className="sidepanel-sub-box">
                                <div style={{marginTop: '10px', marginLeft: '10px'}}>
                                    <img src={TradeAnalyticsSidebar_img4}/>
                                    <span className="sidepanel-sub-box-title" style={{fontSize: '13px'}}>{responseData?.procure360DashboardAccess ? "4" : "3"}: Get Complete Dashboard Data</span>
                                </div>
                                <div className="sidepanel-sub-box-content" style={{fontSize: '12px', margin: '10px 15px'}}> 
                                    Download the complete data of the Procure 360 Dashboard
                                </div>
                                <div>
                                    <span style={{display: 'flex', justifyContent: 'flex-end'}}>
                                        <Button
                                                className=""
                                                // iconTrailing={"arrow_forward"}
                                                size="medium"
                                                style={{color:"#034895", fontSize: '12px', marginRight: '10px'}}
                                                text="Download data"
                                                variant="tertiary"
                                                onClick={function clickButton() {
                                                    window.open(responseData?.completeDashboardDataURL, "_blank", "noopener")
                                                }}
                                        />
                                    </span>
                                    
                                </div>
                        </div>
                </div>
                
                    
                </>    
        )
    }

    else if(page == "ExIM"){
        return(
            <>    
                <div className="sidepanel-full-box">
                    <div className="sidepanel-header" style={{margin: '10px'}}>
                        Resources
                    </div>
                    <div style={{margin: '10px'}}>
                        <span className="sidepanel-sub-header" >Review these recommended onboarding resources for helpful, optional guidance.</span>
                    </div>
                   
                                    <div className="sidepanel-sub-box">
                                        <div style={{marginTop: '10px', marginLeft: '10px'}}>
                                            <span>
                                                <img src={TradeAnalyticsSidebar_img1}/>
                                            </span>

                                            <span className="sidepanel-sub-box-title" style={{fontSize: '13px'}}>1: Access the Ex-Im Dashboard</span>

                                            
                                        </div>
                                        <div className="sidepanel-sub-box-content" style={{fontSize: '12px', margin: '10px 15px'}}>
                                            Access the complete Ex-Im Dashboard, powered by SmartCube
                                        </div>
                                        <div>
                                            <span style={{display: 'flex', justifyContent: 'flex-end'}}>
                                                <Button
                                                    className=""
                                                    // iconTrailing={"arrow_forward"}
                                                    size="medium"
                                                    style={{color:"#034895", fontSize: '12px', marginRight: '10px'}}
                                                    text="Download Ex-Im Dashboard"
                                                    variant="tertiary"
                                                    onClick={function clickButton() {
                                                      
                                                        window.open(responseData?.resourceUrl?.exImUrl, "_blank", "noopener")
                                                    }}
                                                />
                                            </span>
                                            
                                            <div className="sidepanel-sub-box-content" style={{fontSize: '12px', margin: '5px 15px'}}>
                                                Setup Guide for Dashboard:
                                            </div>
                                            <span style={{display: 'flex', justifyContent: 'flex-end'}}>
                                                <Button
                                                    className=""
                                                    // iconTrailing={"arrow_forward"}
                                                    size="medium"
                                                    style={{color:"#034895", fontSize: '12px', marginRight: '10px', position: 'relative', right: '3.5rem'}}
                                                    text="Setup Video"
                                                    variant="tertiary"
                                                    onClick={function clickButton() {
                                                        window.open(responseData?.resourceUrl?.setupVideoUrl, "_blank", "noopener")
                                                    }}
                                                />
                                                <Button
                                                    className=""
                                                    // iconTrailing={"arrow_forward"}
                                                    size="medium"
                                                    style={{color:"#034895", fontSize: '12px', marginRight: '10px'}}
                                                    text="Setup Manual"
                                                    variant="tertiary"
                                                    onClick={function clickButton() {
                                                        window.open(responseData?.resourceUrl?.setupManualUrl, "_blank", "noopener")
                                                    }}
                                                />
                                            </span>
                                        </div>
                                </div>
                  
                    <div className="sidepanel-sub-box">
                            <div style={{marginTop: '10px', marginLeft: '10px'}}>
                                <img src={TradeAnalyticsSidebar_img3}/>
                                <span className="sidepanel-sub-box-title" style={{fontSize: '13px'}}>2: Explore Navigation Guides</span>
                            </div>
                            <div className="sidepanel-sub-box-content" style={{fontSize: '12px', margin: '10px 15px'}}>
                                Go through the Video/Manual to know more
                            </div>
                            {/* <div>
                                <span style={{display: 'flex', justifyContent: 'flex-end'}}>
                                    <Button
                                        className=""
                                        // iconTrailing={"arrow_forward"}
                                        size="medium"
                                        style={{color:"#034895", fontSize: '12px', marginRight: '10px', position: 'relative', right: '3.5rem'}}
                                        text="Setup Video"
                                        variant="tertiary"
                                        onClick={function clickButton() {
                                            window.open(responseData?.resourceUrl?.setupVideoUrl, "_blank", "noopener")
                                        }}
                                    />
                                    <Button
                                        className=""
                                        // iconTrailing={"arrow_forward"}
                                        size="medium"
                                        style={{color:"#034895", fontSize: '12px', marginRight: '10px'}}
                                        text="Setup Manual"
                                        variant="tertiary"
                                        onClick={function clickButton() {
                                            window.open(responseData?.resourceUrl?.setupManualUrl, "_blank", "noopener")
                                        }}
                                    />
                                </span>
                                
                            </div> */}
                            <div>
                                <span style={{display: 'flex', justifyContent: 'flex-end'}}>
                                    <Button
                                        className=""
                                        // iconTrailing={"arrow_forward"}
                                        size="medium"
                                        style={{color:"#034895", fontSize: '12px', marginRight: '10px'}}
                                        text="Navigation Video"
                                        variant="tertiary"
                                        onClick={function clickButton() {
                                            window.open(responseData?.resourceUrl?.dashboardNavigationVideoUrl, "_blank", "noopener")
                                        }}
                                    />
                                    <Button
                                        className=""
                                        // iconTrailing={"arrow_forward"}
                                        size="medium"
                                        style={{color:"#034895", fontSize: '12px', marginRight: '10px'}}
                                        text="Navigation Manual"
                                        variant="tertiary"
                                        onClick={function clickButton() {
                                            window.open(responseData?.resourceUrl?.dashboardNavigationManualUrl, "_blank", "noopener")
                                        }}
                                    />
                                </span>
                                
                            </div>
                    </div>
                    <div className="sidepanel-sub-box">
                            <div style={{marginTop: '10px', marginLeft: '10px'}}>
                                <img src={TradeAnalyticsSidebar_img4}/>
                                <span className="sidepanel-sub-box-title" style={{fontSize: '13px'}}>3: Get Complete Dashboard Data</span>
                            </div>
                            <div className="sidepanel-sub-box-content" style={{fontSize: '12px', margin: '10px 15px'}}> 
                                Download the complete data of the Ex-Im Dashboard​
                            </div>
                            <div>
                                <span style={{display: 'flex', justifyContent: 'flex-end'}}>
                                    <Button
                                            className=""
                                            // iconTrailing={"arrow_forward"}
                                            size="medium"
                                            style={{color:"#034895", fontSize: '12px', marginRight: '10px'}}
                                            text="Download data"
                                            variant="tertiary"
                                            onClick={function clickButton() {
                                                window.open(responseData?.resourceUrl?.downloadUrl, "_blank", "noopener")
                                            }}
                                    />
                                </span>
                                
                            </div>
                    </div>
               </div>
               
                
            </>    
    )

    }
    


		

}

export default TradAnalyticsSidePanel;